<template>
  <div class="batchRenew pointer">
    <NavBar title="批量操作"></NavBar>
    <div class="content">
      <div class="navRticle">
        <div
          :class="active == index ? 'active' : ''"
          v-for="(list, index) in listData"
          :key="index"
          @click="earAway(index)"
        >
          {{ list.deviceName }}
        </div>
      </div>
      <div class="cardBox">
        <div
          class="card"
          v-for="(item, index1) in listData[active].children"
          :key="index1"
        >
          <div class="information">
            <div class="mationLeft" @click.stop="unfold(index1)">
              <div class="nameTop">
                <div class="groupNameBox">
                  <div class="groupName">{{ item.satName }}</div>
                  <div class="instanceLength">
                    共{{ item.children.length }}台
                  </div>
                </div>
                <img
                  v-show="item.showStatus"
                  src="@/assets/imgs/groupingTop1.png"
                  alt=""
                />
                <img
                  v-show="!item.showStatus"
                  src="@/assets/imgs/groupingBottom1.png"
                  alt=""
                />
              </div>
            </div>
            <div class="mationRight">
              <van-checkbox
                v-model="item.result"
                checked-color="#8572eb"
                :ref="'checkboxGroup' + index1"
                @click="checkAllMember(index1, item.result)"
                :disabled="item.children.length > 0 ? false : true"
              ></van-checkbox>
            </div>
          </div>
          <div
            class="listEquipment"
            v-show="item.showStatus && item.children.length > 0"
          >
            <van-checkbox-group v-model="result" :ref="'checkboxes' + index1">
              <van-cell-group :border="false">
                <van-cell
                  v-for="(item2, index2) in item.children"
                  :key="item2.id"
                  clickable
                  @click.stop="toggle(index1, index2)"
                  :border="false"
                  class="cellItem"
                >
                  <template #title>
                    <div class="shebei_title">
                      <div class="shebei_content">
                        <p class="p1">
                          <span class="deviceType">{{
                            getDeviceType(
                              item2.vipCode,
                              item2.deviceVersionCode,
                              item2.vipName
                            )
                          }}</span>
                          {{ item2.instanceName }}
                        </p>
                        <div class="p2">
                          <img
                            class="idIcon"
                            src="@/assets/imgs/ID.png"
                            alt=""
                          />
                          <p class="id">{{ item2.instanceId }}</p>
                        </div>
                      </div>
                      <div class="instanceItem">
                        剩余时间：{{ formatSeconds(item2.expireSeconds) }}
                      </div>
                    </div>
                  </template>
                  <template #right-icon>
                    <van-checkbox
                      :name="item2"
                      checked-color="#8572eb"
                      :ref="'checkboxes' + index1 + index2"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="baseBox" v-if="result.length > 0">
        <div class="affirm" @click="toRenewCloudPhone">
          {{ result.length }}台{{ listData[active].deviceName }}云手机续费
        </div>
      </div>
    </div>
  </div>
</template>
        
        <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { instancelist } from "@/api/index.js";
import { mapMutations } from "vuex";
import buyCode from "@/utils/buyCode";
export default {
  name: "BatchRenew",
  components: {
    NavBar,
  },
  data() {
    return {
      active: 0,
      aliasOptions: [
        {
          label: "B",
          value: "baidu",
        },
        {
          label: "S",
          value: "huoshan",
        },
        {
          label: "Z",
          value: "intelligent",
        },
        {
          label: "H",
          value: "huawei",
        },
      ],
      listData: [{ deviceName: "" }],
      result: [],
    };
  },
  mounted() {
    this.getInstancelist();
  },
  methods: {
    ...mapMutations("perpetual", ["SET_RENEWLIST"]),
    toRenewCloudPhone() {
      this.$router.push({
        path: "/renewCloudPhone",
      });
      this.SET_RENEWLIST(this.result);
    },
    earAway(index) {
      if (this.active != index) {
        this.active = index;
        this.emptyChecked();
      }
    },
    //初始化数据请求
    getInstancelist() {
      instancelist().then((res) => {
        if (res.code == 200) {
          const arr = res.data.filter(
            (item) => item.customize != "2" && !item.overSoldDevice
          );
          if (arr.length > 0) {
            const filteredArr = arr.filter((item) => item.vipName !== "SVIP");
            this.listData = this.dajianshi_arr1to3(filteredArr);
          }
        }
      });
    },
    // 初始化数据格式改变，扁平化数组转为多维数组
    dajianshi_arr1to3(arr) {
      arr.forEach((item) => {
        item.pseudonym =
          item.deviceVersionName + "/" + this.getAliasText(item.channelCode);
      });
      let keys = Object.keys(arr[0]);
      let level1 = "vipName"; //获取一级属性名称
      let level2 = "pseudonym"; //获取二级属性名称
      let list = Array.from(
        new Set(
          arr.map((item) => {
            return item[level1];
          })
        )
      );
      let subList = [];
      list.forEach((res) => {
        arr.forEach((ele) => {
          if (ele[level1] === res) {
            let nameArr = subList.map((item) => item.deviceName);
            if (nameArr.indexOf(res) !== -1) {
              let nameArr2 = subList[nameArr.indexOf(res)].children.map(
                (item) => item.satName
              );
              if (nameArr2.indexOf(ele[level2]) !== -1) {
                subList[nameArr.indexOf(res)].children[
                  nameArr2.indexOf(ele[level2])
                ].children.push({
                  ...ele,
                });
              } else {
                subList[nameArr.indexOf(res)].children.push({
                  satName: ele[level2],
                  //   satGroupName: ele.satGroupName,
                  children: [
                    {
                      ...ele,
                    },
                  ],
                });
              }
            } else {
              subList.push({
                deviceName: res,
                // label: res,
                children: [
                  {
                    satName: ele[level2],
                    // satGroupName: ele.satGroupName,
                    children: [
                      {
                        ...ele,
                      },
                    ],
                  },
                ],
              });
            }
          }
        });
      });
      return subList;
    },
    formatSeconds(totalSeconds) {
      // 计算各时间单位
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      // 生成单位映射
      const units = ["天", "小时", "分"];
      // 构建结果数组
      const parts = [];
      if (days > 0) parts.push(`${days}${units[0]}`);
      if (hours > 0) parts.push(`${hours}${units[1]}`);
      if (minutes > 0 && totalSeconds < 86400)
        parts.push(`${minutes}${units[2]}`);
      // 处理全0情况
      if (parts.length === 0) return `0${units[3]}`;
      return parts.join("");
    },
    unfold(index) {
      this.listData[this.active].children[index].showStatus =
        !this.listData[this.active].children[index].showStatus;
      this.$forceUpdate();
    },
    toggle(index, index1) {
      this.$refs["checkboxes" + index + index1][0].toggle();
      setTimeout(() => {
        let isTrue = this.$refs["checkboxes" + index][0].$children.every(
          (item) => item.checked == true
        );
        if (isTrue) {
          if (!this.listData[this.active].children[index].result) {
            this.$refs["checkboxGroup" + index][0].toggle();
          }
        } else {
          if (this.listData[this.active].children[index].result) {
            this.$refs["checkboxGroup" + index][0].toggle();
          }
        }
        this.repulsionChecked(index);
      }, 50);
    },

    // 全选，全不选
    checkAllMember(index, type) {
      // this.$refs.checkboxGroup
      // this.$refs["checkboxes" + index][0].toggleAll(type);
      if (type) {
        for (
          let i = 0;
          i < this.$refs["checkboxes" + index][0].$children.length;
          i++
        ) {
          this.$refs["checkboxes" + index][0].$children[i].checked = true;
          this.$refs["checkboxes" + index][0].$children[i].toggle(type);
        }
      } else {
        for (
          let i = 0;
          i < this.$refs["checkboxes" + index][0].$children.length;
          i++
        ) {
          this.$refs["checkboxes" + index][0].$children[i].checked = false;
          this.$refs["checkboxes" + index][0].$children[i].toggle(type);
        }
      }
      setTimeout(() => {
        this.repulsionChecked(index);
      }, 50);
    },
    // 清空
    emptyChecked() {
      this.listData[this.active].children.forEach((item, index) => {
        this.$refs["checkboxes" + index][0].$children.forEach(
          (element, number) => {
            this.$refs["checkboxes" + index + number][0].toggle(false);
            this.$refs["checkboxGroup" + index][0].toggle(false);
          }
        );
      });
    },
  },
  computed: {
    getAliasText: {
      get() {
        return function (status) {
          let item = this.aliasOptions.find((item) => item.value == status);
          if (item) {
            return item.label;
          } else {
            return "X";
          }
        };
      },
    },
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode, vipName) {
          let item = buyCode.deviceTypeOptions.find(
            (item) => item.vipCode == vipCode || item.vipName == vipName
          );
          if (item) {
            return `${item.vipType}${deviceVersionCode.substring(1)}`;
          } else {
            if (deviceVersionCode) {
              const customVipType =
              vipName.length >= 2 ? vipName.substring(0, 2) : "定制";
              return `${customVipType}${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
};
</script>
        
    <style lang="less" scoped>
.batchRenew {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    touch-action: manipulation;
    scrollbar-width: none;
    .navRticle {
      width: 100%;
      font-weight: 600;
      font-size: 15px;
      color: #b8bdcc;
      height: 42px;
      line-height: 42px;
      padding: 0 16px;
      overflow-x: auto;
      white-space: nowrap;
      scrollbar-width: none;
      text-align: left;

      & > div {
        margin-right: 24px;
        // margin-top: 5px;
        min-width: 80px;
        min-height: 20px;
        display: inline-block;
        text-align: center;
      }
      .active {
        font-weight: bold;
        font-size: 15px;
        color: #222222;
        position: relative;
        margin-top: 0;
      }
      .active::before {
        content: "";
        position: absolute;
        bottom: 5px;
        left: 50%;
        z-index: 0;
        width: 21px;
        height: 4px;
        background: #886df3;
        border-radius: 21px 21px 21px 21px;
        transform: translateX(-50%);
      }
    }
    .cardBox {
      padding: 0 13px;
      .card {
        margin-top: 10px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 10px 0;
        border-radius: 10px;
        .information {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 16px;
          height: 42px;
          .mationLeft {
            width: 90%;
            .nameTop {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 17px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-bottom: 4px;
              margin-right: 12px;
              img {
                width: 17px;
              }
              .groupNameBox {
                display: flex;
                align-items: center;
                .groupName {
                  font-weight: 500;
                  font-size: 17px;
                  color: #505465;
                }
                .instanceLength {
                  font-weight: 400;
                  font-size: 13px;
                  color: #b8bdcc;
                  line-height: 15px;
                  margin-left: 8px;
                }
              }
            }
          }
          .mationRight {
            height: 24px;
            img {
              width: 24px;
            }
            .rightImg1 {
              margin-right: 12px;
            }
          }
        }
        .listEquipment:before {
          content: "";
          width: 319px;
          border: 1px solid #f5f7fb;
          height: 0px;
          position: absolute;
          top: -4px;
          left: 50%;
          transform: translateX(-50%);
        }
        .listEquipment {
          position: relative;
          margin-top: 17px;
          .listNape {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 64px;
          }
          .cellItem {
            padding: 5px 16px;
            border-radius: 12px;
            .shebei_title {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-right: 8px;
              img {
                width: 40px;
                height: 40px;
                border-radius: 20px;
              }
              .shebei_content {
                // margin-left: 16px;
                text-align: left;
                p {
                  margin: 0;
                  height: 22px;
                  font-size: 13px;
                  font-weight: 400;
                  color: #999999;
                  line-height: 22px;
                }
                .p1 {
                  font-weight: 500;
                  font-size: 15px;
                  color: #505465;
                }
                .p2 {
                  display: flex;
                  align-items: center;
                  .idIcon {
                    width: 18px;
                    height: 17px;
                    margin-right: 4px;
                  }
                  .id {
                    font-weight: 500;
                    font-size: 10px;
                    color: #b8bdcc;
                  }
                }
              }
              .instanceItem {
                font-weight: 400;
                font-size: 13px;
                color: #a9adb6;
              }
            }
            .check {
              margin-right: 2px;
            }
          }
        }
      }
    }
  }
  .baseBox {
    width: 100%;
    height: 56px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .affirm {
      width: 350px;
      height: 42px;
      line-height: 42px;
      background: #886df3;
      border-radius: 21px;
      font-weight: 600;
      font-size: 15px;
      color: #ffffff;
    }
  }
}
/deep/.van-tabs__line {
  width: 22px;
  height: 4px;
  border-radius: 220px;
  bottom: 22px;
}
</style>